import React from "react";
import logo from "../assets/SmartCool-LOGO.png";

const serviceLinks = [
  "HVAC Design",
  "Equipment Supply",
  "Installation Services",
  "Repair & Maintenance",
  "Energy Audits",
  "Technical Consultancy",
];

export default function Footer() {
  return (
    <footer className="bg-white font-poppins">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10">

        {/* Col 1 — Logo */}
        <div>
          <img src={logo} alt="SmartCool Logo" className="h-10 sm:h-12 w-auto mb-3" />
          <p className="text-gray-500 text-sm leading-relaxed">
            Providing reliable HVAC solutions for<br className="hidden sm:block" />comfortable and energy-efficient spaces
          </p>
        </div>

        {/* Col 2 — Services */}
        <div>
          <h4
            className="font-bold text-sm sm:text-base mb-1 pb-2 tracking-wide"
            style={{ color: "#0F1030", borderBottom: "2px solid #00C7EF" }}
          >
            SERVICES
          </h4>
          <ul className="mt-3 space-y-2">
            {serviceLinks.map((s) => (
              <li key={s} className="flex items-center gap-2 text-gray-600 text-xs sm:text-sm cursor-pointer hover:text-cyan-500 transition-colors">
                <span style={{ color: "#0F1030" }}>•</span>{s}
              </li>
            ))}
          </ul>
        </div>

        {/* Col 3 — Contact + Socials */}
        <div className="space-y-3 sm:space-y-4">

          {/* Phone — both numbers call directly */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "#0F1030" }}>
              <svg className="w-4 h-4" fill="white" viewBox="0 0 24 24">
                <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
              </svg>
            </div>
            <div className="text-xs sm:text-sm">
              <a href="tel:+256200937979" className="block text-gray-600 hover:text-cyan-500 transition-colors">+256-200-937-979</a>
              {/* <a href="tel:+256752873187" className="block text-gray-600 hover:text-cyan-500 transition-colors">+256-752-873-187</a> */}
            </div>
          </div>

          {/* Email — opens email client directly */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "#0F1030" }}>
              <svg className="w-4 h-4" fill="white" viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
            </div>
            <a href="mailto:info@smartcool.co.ug" className="text-xs sm:text-sm text-gray-600 hover:text-cyan-500 transition-colors">
              info@smartcool.co.ug
            </a>
          </div>

          {/* Location */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "#0F1030" }}>
              <svg className="w-4 h-4" fill="white" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
              </svg>
            </div>
            <p className="text-xs sm:text-sm text-gray-600">Kampala, Uganda</p>
          </div>

          {/* Socials — links to be added later */}
          <div className="flex gap-3 pt-1">
            {[
              { icon: <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>, href: "#" },
              { icon: <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 6a2 2 0 100-4 2 2 0 000 4z"/>, href: "#" },
              { icon: <><rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="white" strokeWidth="2"/><circle cx="12" cy="12" r="4" fill="none" stroke="white" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="white"/></>, href: "#" },
            ].map((s, i) => (
              <a
                key={i}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                style={{ backgroundColor: "#0F1030" }}
              >
                <svg className="w-4 h-4" fill="white" viewBox="0 0 24 24">{s.icon}</svg>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="py-3 sm:py-4 text-center text-white text-xs sm:text-sm font-semibold" style={{ backgroundColor: "#0F1030" }}>
        © 2026 All Copyrights Reserved.
      </div>
    </footer>
  );
}